module.exports = __webpack_public_path__ + "af2b56da546a005fff9b402fce494851.fbx";